import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import { setNodeData } from '../../../features/mainSlice';
import TextField from '../../shared/TextField';

const useStyles = makeStyles(
  () => ({
    name: {
      marginBottom: '36px',
      '& > .input-title': {
        fontSize: '15px',
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1',
        letterSpacing: 'normal',
        color: color.$3,
        marginBottom: '12px',
      },
    },
  }),
  {
    name: 'Name',
  },
);

const Name = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode, isErrorNodeIds } = useSelector(state => state.ma);
  const { name } = selectedNode?.data;
  const isError = !!~isErrorNodeIds.indexOf(selectedNode?.id);

  const setName = event => {
    const { value } = event.target;
    dispatch(setNodeData({ name: value }));
  };

  return (
    <div className={classes.name}>
      <div className="input-title">{t('messages.name')}</div>
      <TextField
        type="text"
        isValid
        placeholder={t('messages.name-placeholder')}
        value={name}
        onChange={setName}
        error={isError && !name}
      />
    </div>
  );
};

export default Name;
